import {
	trigger,
	state,
	animate,
	transition,
	style
} from '@angular/animations';

export const fadeInAnimation = trigger('fadeInAnimation', [
	// route 'enter' transition
	transition(':enter', [
		// styles at start of transition
		style({ opacity: 0.6 }),

		// animation and styles at end of transition
		animate('.4s', style({ opacity: 1 }))
	])
]);
